/**
 * GaugeChart ThresholdIndicator slot definition.
 * @public
 */
export interface GaugeChartThresholdIndicatorProps {
  /**
   * The value of the threshold.
   */
  value: number;
  /**
   * When set to true, it shows the indicator of the threshold.
   * @deprecated Use the top-level `showThresholdIndicators` prop on
   * `GaugeChart` to toggle the visibility of all threshold indicators at once.
   * @defaultValue false
   */
  showIndicator?: boolean;
  /**
   * The color of the threshold.
   * @defaultValue 'Categorical.Color11'
   */
  color?: string;
}

export const ThresholdIndicator = (_props: GaugeChartThresholdIndicatorProps) =>
  null;
